module.exports = __webpack_public_path__ + "img/during.dd30305b.svg";